import {
  Directive,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';
import { AuthorizationService } from '../../core/services/authorization.service';
import { AppApi } from '../../core/api/app.api';
import { APP_PAGES } from '../../pages';
import { ModalController } from '@ionic/angular';
import * as CoreActions from '../../core/store/core/core.actions';
import * as fromApp from '../../core/store/app.reducers';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { TrackingService, ADAPTIVE_BOOK_NOW, ADD_TO_CART } from '../../core/services/tracking.service';

export interface IAuthenticatedEvent {
  requiredAuth: boolean;
}

import * as _ from 'lodash';
import { RequireAuthModalComponent } from './require-auth';
import { AuthModalComponent } from '../../auth-components/auth-modal/auth-modal';

@Directive({
  selector: '[appRequireAuth]'
})
export class RequireAuthDirective {
  @Input() appRequireAuth;
  @Input() formData;
  @Input() funz;
  @Input() redirectParams: { [key: string]: any } = {};
  @Input() authRedirect: APP_PAGES;
  @Output() authenticated = new EventEmitter<IAuthenticatedEvent>();

  @HostListener('click', ['$event'])
  public handleClick(event: MouseEvent) {
    event.stopImmediatePropagation();
    event.preventDefault();
    let isAuthorized = false;
    this.auth.isAuthorized().subscribe(res => (isAuthorized = res));
    if (!isAuthorized) {
      return this.handleNotAuthorized();
    }
    if (_.get(event, 'currentTarget.className', '').includes('order-now-button')) {
      this.trackingService.trackGAEvent(ADAPTIVE_BOOK_NOW);
      this.trackingService.trackGAEvent(ADD_TO_CART);
    }
    this.handleAuthorized();
    return false;
  }

  constructor(
    private auth: AuthorizationService,
    private appApi: AppApi,
    public modalCtrl: ModalController,
    private translateService: TranslateService,
    private store: Store<fromApp.IAppState>,
    private trackingService: TrackingService,
  ) {}

  async handleNotAuthorized() {
    const authModal = await this.modalCtrl.create({
      component: RequireAuthModalComponent,
      cssClass: 'auth-popup'
    });
    await authModal.present();
    const authType = await authModal.onDidDismiss();
    if (authType.data) {
      const modal = await this.modalCtrl.create({
        component: AuthModalComponent,
        componentProps: { authType: authType.data }
      });
      await modal.present();
      modal.onDidDismiss().then(isAuthenticated => {
        if (isAuthenticated.data) { this.handleAuthorized(); }
      });
    }
  }

  handleAuthorized(requiredAuth = false) {
    this.authenticated.emit({ requiredAuth });
  }
}
